import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";

const LINKS = [
  { name: "The Opportunity", path: "/opportunity", id: "nav-opportunity" },
  { name: "Technology", path: "/technology", id: "nav-technology" },
  { name: "Intellectual Property", path: "/intellectual-property", id: "nav-ip" },
  { name: "Partnering & Supply", path: "/partnering", id: "nav-partnering" },
  { name: "About & Contact", path: "/about-contact", id: "nav-contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-white/85 border-b border-line">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between gap-6">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 shrink-0" onClick={() => setOpen(false)}>
          <img src="/logo-transparent.png" alt="Chocolate Detox logo" className="w-10 h-10 object-contain" />
          <span className="leading-none">
            <span className="block font-headline font-semibold tracking-tight text-[15px] text-ink">CHOCOLATE DETOX</span>
            <span className="block font-mono text-[9px] uppercase tracking-[0.28em] text-faint mt-1">LLC · Madison, WI</span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-7" aria-label="Primary">
          {LINKS.map((l) => (
            <NavLink
              key={l.path}
              to={l.path}
              data-testid={l.id}
              className={({ isActive }) =>
                `text-[13px] font-medium transition-colors duration-200 ${
                  isActive ? "text-pine" : "text-smoke hover:text-ink"
                }`
              }
            >
              {l.name}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/partnering"
            data-testid="nav-partnering-cta-button"
            className="hidden sm:inline-flex items-center gap-1.5 bg-pine hover:bg-pinehover text-white text-[13px] font-medium px-4 py-2 transition-colors duration-200"
          >
            Partnership Enquiries <ArrowUpRight size={14} />
          </Link>
          <button
            data-testid="mobile-menu-button"
            className="lg:hidden p-2 text-ink"
            onClick={() => setOpen(!open)}
            aria-label="Toggle navigation menu"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <nav className="lg:hidden border-t border-line bg-white" aria-label="Mobile">
          <div className="px-5 py-4 flex flex-col">
            {[{ name: "Home", path: "/", id: "nav-home-mobile" }, ...LINKS].map((l) => (
              <Link
                key={l.path + l.id}
                to={l.path}
                data-testid={`${l.id}-mobile`}
                onClick={() => setOpen(false)}
                className={`py-3 text-sm font-medium border-b border-line/60 last:border-0 ${
                  location.pathname === l.path ? "text-pine" : "text-smoke"
                }`}
              >
                {l.name}
              </Link>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
};
